@if (rfi) {
  <div class="maincontainer">
    <div class="contentcontainer">
      <div class="col-6 leftHalf">
        <leftPanel [defaultTab]="defaultTab"></leftPanel>
      </div>
      <div class="col-6 rightHalf">
        <div class="row">
          <div class="col-12">
            <div class="page-header" style="align-items: baseline">
              <div class="header-actions">
                <aecom-button
                  [theme]="'light'"
                  innerClass="btn lg outline orange"
                  (click)="back()"
                  >
                  BACK
                </aecom-button>
                @if (showReassignBtn) {
                  <aecom-button
                    innerClass="btn lg outline blue"
                    (click)="reassign()"
                    data-cy="reassign"
                    >
                    Reassign
                  </aecom-button>
                }
                @if (showPrint) {
                  <aecom-button
                    innerClass="btn lg solid blue"
                    (click)="generateReport()"
                    >
                    DOWNLOAD AS PDF
                  </aecom-button>
                }
                @if (IsReject && (IsDbAdmin || IsDocControl)) {
                  <aecom-button
                    [theme]="'light'"
                    innerClass="btn lg outline orange"
                    (click)="voidRFI()"
                    >
                    Void
                  </aecom-button>
                }
                @if (IsReject && (IsDbAdmin || IsDocControl)) {
                  <aecom-button
                    innerClass="btn lg solid blue"
                    (click)="reviseRFI()"
                    >
                    Revise
                  </aecom-button>
                }
                @if (showRecallButton) {
                  <aecom-button
                    data-testid="requestCancelBtn"
                    innerClass="btn lg outline blue"
                    (click)="recallRFI()"
                    >
                    Request to Cancel
                  </aecom-button>
                }
                @if (isRecalled && IsDocControl && rfi.Status !== 'Canceled') {
                  <aecom-button
                    [theme]="'light'"
                    innerClass="btn lg solid blue"
                    (click)="submitRFI()"
                    >
                    Submit
                  </aecom-button>
                }
                @if (showReopenBtn) {
                  <aecom-button
                    innerClass="btn lg outline blue"
                    (click)="reopen()"
                    >
                    Reopen
                  </aecom-button>
                }
                <!-- <aecom-button
                *ngIf="showReopenAcknowledge"
                [innerClass]="acknowledge?'btn lg solid blue':'btn lg outline blue'"
                (click)="reopenApproval()"
                >
                Submit
              </aecom-button> -->
            </div>
          </div>
        </div>
      </div>
      @if (isRecalled) {
        <aecom-form-group
          columnSpan="6"
          columns="2"
          [title]="
            IsDocControl && rfi.Status != 'Canceled'
              ? 'Recall Request'
              : 'Recall Reason'
          "
          >
          @if (isRecalled) {
            <aecom-form-item
              [label]="'Note from Design Builder'"
              columnSpan="2"
              >
              <div class="button-wrapper d-flex" [innerHtml]="note">
              </div>
            </aecom-form-item>
          }
          @if (IsDocControl && rfi.Status != 'Canceled') {
            <aecom-form-item
              [label]="'Do you accept Recall?'"
              columnSpan="1"
              >
              <div class="button-wrapper d-flex">
                <aecom-button
                innerClass="btn solid btn-tab {{
                  !response.ShowRecallRejected ? 'blue' : 'bg-grey-e'
                }}"
                  (click)="setAcceptRecall(false)"
                  >
                  Yes
                </aecom-button>
                <aecom-button
                innerClass="btn solid btn-tab {{
                  response.ShowRecallRejected ? 'blue' : 'bg-grey-e'
                }}"
                  (click)="setAcceptRecall(true)"
                  >
                  No
                </aecom-button>
              </div>
            </aecom-form-item>
          }
        </aecom-form-group>
      }
      @if (!isRecalled) {
        <div class="tab-container">
          <div class="tab-header">
            @if (!IsReject && !IsCancel) {
              <span class="tab-title">
                RFI Response
              </span>
            }
            @if (IsReject || IsCancel) {
              <span class="tab-title">
                QA/QC Failed Note by :
                <span class="color-red">{{ rejectedBy }}</span>
              </span>
            }
          </div>
        </div>
        @if (IsReject || IsCancel) {
          <div class="bottom-padding pt-24">
            <div class="content-value" [innerHtml]="rejectedNotes">
            </div>
          </div>
        }
        @if (!IsReject && !IsCancel && !IsResponded) {
          <div
            class="text-center"
            style="padding-top: 35px"
            >
            <div class="rfi-response-padding">
              <i class="icon icon-action-basic_todo"></i>
              <div class="rfi-response-text rfi-response-text-padding">
                No Response Yet
              </div>
            </div>
          </div>
        }
        @if (!IsReject && !IsCancel && IsResponded) {
          <div
            style="padding-top: 35px"
            class="bottom-padding"
            >
            <span class="content-header">Response</span>
            <div class="content-value" [innerHtml]="rfi.OfficialResponse">
            </div>
          </div>
        }
        @if (!IsReject && !IsCancel && IsResponded) {
          <div
            style="padding-top: 35px"
            class="bottom-padding"
            >
            <bbj-file-list
              title="Attachments"
              [fileList]="docFiles"
              [allowMovingFiles]="false"
            ></bbj-file-list>
          </div>
        }
        @if (showReopenItem) {
          <reopen-detail [reopen]="reopenItem" [readonly]="true" style="grid-column: span 12; margin: 40px 0; display: block;"></reopen-detail>
        }
        @if (showReopenAcknowledge) {
          <aecom-form-group
            columnSpan="12"
            columns="4"
            title="Acknowledge Change?"
            class="headerSubTitle"
            style="margin: 40px 0; display: block;"
            >
            <aecom-form-item data-cy="acknowledge" columnSpan="1">
              <div class="button-wrapper d-flex">
                <aecom-button
                  innerClass="btn solid btn-tab blue"
                  (click)="reopenApproval()"
                  >
                  Yes
                </aecom-button>
              </div>
            </aecom-form-item>
          </aecom-form-group>
        }
      }
    </div>
  </div>
</div>
}

<ng-template #notAvailable>
  <div class="itemText">N/A</div>
</ng-template>
@if (showReport) {
  <div class="up-contentcontainer">
    <app-report [rfi]="rfi" [rfiDocuments]="rfiDocuments" (closeWindow)="closeReport($event)"></app-report>
  </div>
}